import { ChangeDetectorRef, HostListener, Input, ChangeDetectionStrategy, Component, input, inject } from '@angular/core';
import { Client } from '@df/core/service/client';
import { DfModuleImageModule } from '@df/module-image/df-module-image.module';

/**
 * Component that toggles images when hovered
 * Needs to be wrapped with a ratiod container
 */
@Component({
    selector: 'product-alt-image',
    templateUrl: './product-alt-image.html',
    styleUrls: ['./product-alt-image.scss'],
    host: {
        '(mouseenter)': 'onMouseEnter()'
    },
    imports: [DfModuleImageModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductAltImageComponent {
    readonly mainImage = input.required<string>();

    /**
     * Alternative image visible on hover
     */
    readonly altImage = input<string>();
    readonly altText = input<string>();

    private hovered = false;
    private readonly client = inject(Client);
    private readonly changeDetectorRef = inject(ChangeDetectorRef);

    onMouseEnter() {
        if (!this.hovered) {
            this.hovered = true;
            this.changeDetectorRef.detectChanges();
        }
    }

    /**
     * Alternative image is only printed after first time it was needed
     */
    canPrintAltImage(): boolean {
        return !this.client.isTouchy && !!(this.hovered && this.altImage());
    }
}
